export default __webpack_public_path__ + "static/media/ic_plus_pink.7a1548bc.svg";